module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-green.44a7fa59.svg";